<div class="flex">
  <div class="basis-1/16">
    <mat-icon matListItemIcon>keyboard_arrow_right</mat-icon>
  </div>
  <div class="basis-1/8">{{stock.name}} </div>
  <div class="basis-1/8">{{stock.count}}:kpl </div>
  <div class="basis-1/2 pl-4">{{stock.shippingMethod | shippingMethod}}</div>
</div>
